<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" class="fill-current">
      <path fill="#fff" d="M10.24 7.68h2.56v15.36h-2.56v-15.36z"></path>
      <path fill="#fff" d="M19.2 7.68h2.56v15.36h-2.56v-15.36z"></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="1.28"
        d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
      />
      <path
        fill="none"
        stroke="#fff"
        stroke-linejoin="miter"
        stroke-linecap="butt"
        stroke-miterlimit="4"
        stroke-width="1.28"
        d="M31.36 16c0 8.483-6.877 15.36-15.36 15.36s-15.36-6.877-15.36-15.36c0-8.483 6.877-15.36 15.36-15.36s15.36 6.877 15.36 15.36z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
